export default __webpack_public_path__ + "static/media/background.fdbecc9f.jpg";